module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "form",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": _vm.name
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    ref: "button",
    attrs: {
      "label": "颜色"
    },
    on: {
      "click": _vm.openPopover
    }
  })], 1), _vm._v(" "), _c('mu-popover', {
    attrs: {
      "trigger": _vm.trigger,
      "open": _vm.open
    },
    on: {
      "close": _vm.closePopover
    }
  }, [_c('mu-menu', {
    ref: "content",
    staticClass: "list-content",
    on: {
      "change": _vm.changeMenu
    }
  }, [_c('mu-content-block', [_c('mu-text-field', {
    attrs: {
      "hintText": "搜索",
      "fullWidth": ""
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.colorList), function(color, index) {
    return _c('mu-menu-item', {
      key: index,
      attrs: {
        "title": color.name,
        "value": color.value
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "color_lens",
        "color": color.value
      },
      slot: "after"
    })], 1)
  })], 2)], 1), _vm._v(" "), (_vm.scroller) ? _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading
    },
    on: {
      "load": _vm.loadMoreMaterialIcon
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d2a3b03","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/colorPicker.vue
// module id = 531
// module chunks = 1